'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.directive('viewIntercept', function ($timeout, $ionicTemplateLoader, $compile) {
    var TPL = ['<div class="content-intercept ng-show" ng-show="visible" ng-class="{\'vsi-fail\':!loading}">', '  <ion-spinner class="content-intercept-loading" ng-if="loading"></ion-spinner>', '  <div bind-template-compile="template" ng-if="!loading"></div>', '</div>'].join('');
    return {
      restrict: 'A',
      scope: {
        load: '&viewIntercept'
      },
      compile: function compile() {
        return {
          pre: function pre($scope, $element) {
            $scope.$el = $compile(TPL)($scope)[0];
            $element[0].appendChild($scope.$el);
          }
        };
      },
      controller: function controller($scope) {
        $scope.visible = true;
        $scope.loading = true;
        $scope.reload = function () {
          $scope.loading = true;
          $scope.visible = true;
          $scope.load();
        };

        var templateDefault = require('./default.html');

        function render(template) {
          if (!(0, _objectType.isString)(template)) {
            template = templateDefault;
          }
          $scope.template = template;
          //$scope.$el.append(el);
        }

        $scope.$on('viewShowingIntercept.reload', function () {
          $scope.reload();
        });

        $scope.$on('viewShowingIntercept.done', function () {
          $afterEnter();
          $scope.$evalAsync(function () {
            $scope.visible = false;
          });
        });

        $scope.$on('viewShowingIntercept.fail', function (event, data) {
          $afterEnter();
          $timeout(function () {
            $scope.loading = false;
            if ((0, _objectType.isString)(data)) {
              $scope.message = data;
              render();
            } else if ((0, _objectType.isObject)(data)) {
              if ((0, _objectType.isString)(data.templateUrl)) {
                $ionicTemplateLoader.load(data.templateUrl).then(function (template) {
                  render(template);
                }, function () {
                  render();
                  throw new Error('Could not find the specified template: ' + data.templateUrl);
                });
              } else if ((0, _objectType.isString)(data.template)) {
                render(data.template);
              } else {
                render();
              }
            } else {
              render();
            }
          }, 500);
        });

        var $afterEnter = $scope.$on('$ionicParentView.afterEnter', function () {
          $scope.$evalAsync(function () {
            $scope.reload();
          });
        });
      }
    };
  });
  return app;
};

require('angular');

require('ionic');

var _objectType = require('../../../utils/objectType');

require('./index.scss');

; /**
   * 指令
   * ion-view 显示拦截器
   */


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/directives/viewIntercept/index.js
// module id = 154
// module chunks = 0